// extracted by mini-css-extract-plugin
module.exports = {"subHeadlineWrap":"order-history_subHeadlineWrap__K5aEh","orderItemBlock":"order-history_orderItemBlock__MXJEm"};